// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2q4Vi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__bQWQ-","obliqueLine":"membershipbadge_obliqueLine__3sBs6"};